import * as actions from '../actions/api';
import { setApi } from '../actions/service';

import { v1 } from 'uuid';

import apiUrlDetector from './apiUrlDetector'; //определялка настройек АПИ и переменных
import errorDecryptor from './apiErrorDecryptor'; //список ошибок, которые мы знаем и любим

import ReduxableService from './parentСlasses/ReduxableService'
/*
Предоставляет на this
store         редакс стор
rr            обертка облегчающая доступ к данным в стейте редакса
_c            таймер
actions       задиспатченные actions переданные в конструктоа

_isChange     ф-ция - универсальный проверятор изменений в стейте редакса
_resetC       ф-ция - сбрасывает отсчет таймера (начало времен)
_bindAC       ф-ция - упрощает создание экшенов.

Обеспечивает
вызов ф-ции _storeListener при каждом изменении redux State
*/
export default class ApiService extends ReduxableService{

  constructor(store){
    super(store, actions, setApi)

    //получаем текущие настройки
    const {
      apiHost,
      apiPort,
      apiMethod,
      apiPath,
      apiSuffix,
      siteUrl,
      envType
    }=apiUrlDetector(window.location.href);

    //записываем настройки в поля объекта
    //внутренние переменные, нужные только здесь
    this._host = apiHost;
    this._port = apiPort;
    this._method = apiMethod;
    this._path = apiPath;
    this._suffix = apiSuffix;

    //а эти переменные можно попользовать и во вне
    this.siteUrl = siteUrl;
    this.envType = envType;

    //создаем функции нашего апи
    const a = this.actions;
    const s = ()=>this.rr._api;
    const apiPoints=[
      //{имя ф-ции, ф-ция возвращающая сохраненные данные, метод  сохраняющий данные, адрес точки в api}
      //http://back.elpat.online/api/v1/gobject/get
      {functionName:'getGeoObj', varGet:()=>s()['geoObjs'],saver:a['setGeoObjs'], apiUrl:'gobject/get'},
      {functionName:'getGeoObjReport', varGet:()=>s()['geoObjReport'],saver:a['setGeoObjReport'], apiUrl:'gobject/get/report'},
      {functionName:'getMultiGeoObjReport', varGet:()=>s()['geoMultiObjReport'],saver:a['setMultiGeoObjReport'], apiUrl:'gobject/get/reports'},
      {functionName:'getGeoObjDashboard', varGet:()=>s()['geoObjDashboard'],saver:a['setGeoObjDashboard'], apiUrl:'gobject/get/dashboard'},
      {functionName:'getGeoObjRoute', varGet:()=>s()['geoObjRoute'],saver:a['setGeoObjRoute'], apiUrl:'gobject/get/route'},
      {functionName:'getGeoObjGeozone', varGet:()=>s()['geoObjGeozone'],saver:a['setGeoObjGeozone'], apiUrl:'geozone/get'},
      {functionName:'saveGeoObjGeozone', varGet:()=>s()['savingGeoObjGeozone'],saver:a['setSavingGeoObjGeozone'], apiUrl:'geozone/edit'},
      {functionName:'getGeozoneIntersections', varGet:()=>s()['getDataGeozoneIntersections'],saver:a['setGeozoneIntersections'], apiUrl:'geozone/itersections'},
      {functionName:'getActivitiByZone', varGet:()=>s()['activitiByZone'],saver:a['setActivitiByZone'], apiUrl:'gobject/get/itersections-summary'},

      {functionName:'getGeoObjReportExcel', varGet:()=>s()['geoObjReportExcel'],saver:a['setGeoObjReportExcel'], apiUrl:'gobject/get/reportexcel'},
      {functionName:'getGeoObjVisits', varGet:()=>s()['geoObjVisits'],saver:a['setObjVisits'], apiUrl:'gobject/get/itersections'},
      {functionName:'getMultiGeoObjReportExcel', varGet:()=>s()['geoMultiObjReportExcel'],saver:a['setMultiGeoObjReportExcel'], apiUrl:'gobject/get/reportsexcel'},
      
      {functionName:'getWorkingTimeSheet', varGet:()=>s()['workingTimeSheet'],saver:a['setWorkingTimeSheet'], apiUrl:'gobject/get/report-card'},

      {functionName:'getDirectoryList', varGet:()=>s()['directoryList'],saver:a['setDirectoryList'], apiUrl:'dir/list/get'},
      {functionName:'getDirectoryData', varGet:()=>s()['directoryData'],saver:a['setDirectoryData'], apiUrl:'dir/get'},
      {functionName:'getDirectoryShort', varGet:()=>s()['directoryShort'],saver:a['setDirectoryShort'], apiUrl:'dir/get/short'},

      {functionName:'saveDirectory', varGet:()=>s()['savingDirectory'],saver:a['setSavingDirectory'], apiUrl:'dir/update'},
      {functionName:'addDirectory', varGet:()=>s()['addingDirectory'],saver:a['setAddingDirectory'], apiUrl:'dir/create'},
      {functionName:'deleteDirectory', varGet:()=>s()['deletingDirectory'],saver:a['setDeletingDirectory'], apiUrl:'dir/delete'},

      {functionName:'getDocumentData', varGet:()=>s()['documentData'],saver:a['setDocumentData'], apiUrl:'documents/get'},
      //Эта функция лезет на ту же точку АПИ что и предыдущая, но получает результат по одному документу и потому в другом формате
      //проще сделать отдельную ф-цию со своим хранилищем, чем обеспечивать взаимною изоляцию разных форматов данных
      {functionName:'getSingleDocument', varGet:()=>s()['singleDocument'],saver:a['setSingleDocument'], apiUrl:'documents/get'},
      {functionName:'getSingleDocument2', varGet:()=>s()['singleDocument2'],saver:a['setSingleDocument2'], apiUrl:'documents/get'},
      {functionName:'addDocument', varGet:()=>s()['addingDocument'],saver:a['setAddingDocument'], apiUrl:'documents/create'},
      {functionName:'saveDocument', varGet:()=>s()['savingDocument'],saver:a['setSavingDocument'], apiUrl:'documents/update'},
      {functionName:'deleteDocument', varGet:()=>s()['deletingDocument'],saver:a['setDeletingDocument'], apiUrl:'documents/delete'},
      {functionName:'changeStatusDocument', varGet:()=>s()['changingStatusDocument'],saver:a['setChangeStatusDocument'], apiUrl:'documents/change-status'},
      {functionName:'getPlanWorkDir', varGet:()=>s()['planWorkDir'],saver:a['setPlanWorkDir'], apiUrl:'dir/get/doc-activities'},
      {functionName:'getPlanScheduleStatuses', varGet:()=>s()['planScheduleStatuses'],saver:a['setPlanScheduleStatuses'], apiUrl:'dir/get/doc-statuses'},
      {functionName:'getOrderWorkStatuses', varGet:()=>s()['orderWorkStatuses'],saver:a['setOrderWorkStatuses'], apiUrl:'dir/get/doc-statuses'},
      {functionName:'getFooterInfo', varGet:()=>s()['footerInfo'],saver:a['setFooterInfo'], apiUrl:'main/get'},

      // тревоги !!!
      {functionName:'getAlarmsInfo', varGet:()=>s()['alarmsInfo'],saver:a['setAlarmsInfo'], apiUrl:'gobject/get/alarms'},

      {functionName:'checkLogin', varGet:()=>s()['user'],saver:a['setUser'], apiUrl:'auth/login/check'},
      {functionName:'userLogin', varGet:()=>s()['user'],saver:a['setUser'], apiUrl:'auth/login'},
      {functionName:'userLogout', varGet:()=>s()['user'],saver:a['setUser'], apiUrl:'auth/logout'},
      {functionName:'getRights', varGet:()=>s()['rights'],saver:a['setRights'], apiUrl:'user/rights/get'},

      // {functionName:'resetPwd', varGet:()=>s()['pwdResetStatus'],saver:a['setPwdReset'], apiUrl:'user/pwd/reset'},
      // {functionName:'changePwd', varGet:()=>s()['pwdChangeStatus'],saver:a['setPwdChange'], apiUrl:'user/pwd/change'},
      // {functionName:'getStatus', varGet:this._callGetter,saver:this._callSaver, apiUrl:'map/status/get'},
      // {functionName:'getPoints', varGet:this._callGetter,saver:this._callSaver, apiUrl:'map/points/get'},

      // {functionName:'getStatus2', varGet:()=>s()['statuses'],saver:a['setStatuses'], apiUrl:'map/status/get'},
      // {functionName:'getIcons', varGet:()=>s()['icons'],
      //         saver:a['setIcons'], apiUrl:'map/icon/get'},
      // {functionName:'getSectors2', varGet:()=>s()['sectors'],saver:a['setSectors'], apiUrl:'map/sectors/get'},
      // {functionName:'getPoints2', varGet:()=>s()['allPoints'],saver:a['setAllPoints'], apiUrl:'map/points/get'},
      // {functionName:'savePoint', varGet:()=>s()['savePoint'],saver:a['setSavePoint'], apiUrl:'map/point/save'},
      // {functionName:'saveSectoredPoints', varGet:()=>s()['savePointBySectors'],saver:a['setSavePointBySectors'], apiUrl:'map/points/setsector'},
      // {functionName:'find', varGet:()=>s()['findResult'],saver:a['setFindResult'], apiUrl:'map/point/find'},
      // {functionName:'getAnalitics', varGet:()=>s()['analitics'],saver:a['setAnalitics'], apiUrl:'user/analitics/get'},
      // {functionName:'getAnaliticsDetail', varGet:()=>s()['analiticsDetail'],
      //         saver:a['setAnaliticsDetail'], apiUrl:'user/analitics/detail'},
      // {functionName:'findAddress', varGet:()=>s()['findedAddress'],saver:a['setFindedAddress'], apiUrl:'map/address/find'},
      // {functionName:'sendChekIn', varGet:()=>s()['checkIn'],saver:a['setChekIn'], apiUrl:'map/point/checkin'},
      // {functionName:'sendChekOut', varGet:()=>s()['checkOut'],saver:a['setChekOut'], apiUrl:'map/point/checkout'},
      // {functionName:'sendError', varGet:()=>s()['sendingError'],saver:a['setSendingError'], apiUrl:'ts/error/send'},
      // {functionName:'getFilterList', varGet:()=>s()['filterList'],saver:a['setFilterList'], apiUrl:'map/filter/list/get'},
      // {functionName:'getFilterResult', varGet:()=>s()['filterResult'],saver:a['setFilterResult'], apiUrl:'map/filter/result/get'},
      // {functionName:'getPointColunmOrder', varGet:()=>s()['pointColunmOrder'],
      //         saver:a['setPointColunmOrder'], apiUrl:'map/point/array/order'},
      // {functionName:'getPointDetailArray', varGet:()=>s()['pointDetailArray'],
      //         saver:a['setPointDetailArray'], apiUrl:'map/point/array/get'},

      // {functionName:'getCrmPointStatus', varGet:()=>s()['crmPointStatus'],
      //         saver:a['setCrmPointStatus'], apiUrl:'crm/int/point/get'},
      // {functionName:'sendPointToCrm', varGet:()=>s()['crmPointSending'],
      //         saver:a['setSendingPointToCrm'], apiUrl:'crm/int/point/set'},

      // {functionName:'getUserList', varGet:()=>s()['userList'],
      //         saver:a['setUserList'], apiUrl:'user/list'},
      // {functionName:'getUserDetail', varGet:()=>s()['userDetail'],
      //         saver:a['setUserDetail'], apiUrl:'user/get'},
      // {functionName:'saveUser', varGet:()=>s()['userSaving'],
      //         saver:a['setUserSaving'], apiUrl:'user/save'},
      // {functionName:'getUserRoles', varGet:()=>s()['userRoles'],
      //         saver:a['setUserRoles'], apiUrl:'user/role/get'},
      // {functionName:'getSectorList', varGet:()=>s()['sectorList'],
      //         saver:a['setSectorList'], apiUrl:'map/sectors/list'},


      // {functionName:'getSectors', varGet:this._callGetter,saver:this._callSaver, apiUrl:'map/sectors/get'},
      // {functionName:'getRights', varGet:()=>s()['rights'],saver:a['setRights'], apiUrl:'user/rights/get'},
      // {functionName:'getManagers', varGet:()=>s()['managers'],saver:a['setManagers'], apiUrl:'user/managers/get'},
      // {functionName:'getPoint', varGet:()=>s()['point'],saver:a['setPoint'], apiUrl:'map/point/get'},
      // {functionName:'getPointRelated', varGet:()=>s()['pointRelated'],saver:a['setPointRelated'], apiUrl:'map/point/related/get'},
      // {functionName:'checkAddress', varGet:()=>s()['checkedAddress'],saver:a['setAddress'], apiUrl:'map/address/check'},


      // {functionName:'savePoint', varGet:this._callGetter,saver:this._callSaver, apiUrl:'map/point/save'},

      // {functionName:'getUserProfile', varGet:()=>s()['userProfile'],saver:a['setUserProfile'], apiUrl:'user/profile/get'},

      //т.к. _getAvatar и _putAvatar работают с переданными им ф-циями getter/setter то они едины для обеих методов
      // {functionName:'loadAvatar', varGet:this._getAvatar,saver:this._putAvatar, apiUrl:'ucr/avatar/get'},
    ];
    apiPoints
      .forEach(({functionName, varGet,saver, apiUrl})=>{
        this[functionName]=this._makeApiPoint(varGet, saver, apiUrl);
        console.log('debug создаем ф-цию ', functionName);
      })

  }

  //внутренние ф-ции
  _makeApiPoint = (varGet, saverfunction, apiUrl) => {
    //Функция создающая функции обмена данными.
    //это ф-ция высшего порядка, которая будет использована при инициации
    //для создания кучи ф-ций из массива
    //varGet - ф-ция отдающая хранимые данные
    //saverName ф-ция сохраняющий данные
    //apiUrl адрес точки в api
    return (async (payload, ...rest) => {
      console.log(`debug вызов ф-ции для доступа к ${apiUrl}`)
      const dataGetter = ()=>varGet(...rest);
      const dataSetter = (data)=>saverfunction(data, ...rest)

      const getData = async (from)=>{
        const result = await this._dataLoader({
          point:apiUrl,
          payload,
          varGet:dataGetter,
          varSaver:dataSetter,
          from
        })
        if(result?.meta?.sessionId && (this.rr.service_Session?.sessionId || this.rr.service_Session?.sessionId==='')){
          this.rr.service_Session.sessionId=result.meta.sessionId;
        }
        return result;
      }
      const saveErr = (err) => {
        dataSetter({...dataGetter(), error:err});
      }
      const saveErrEndLoading = (err) => {
        dataSetter({...dataGetter(), error:err,loading:undefined});
      }

      //
      let resp;
      let dataObj = dataGetter();
      //Возможные варианты в рамках жизненного цикал объекта:
      //    dataObj===undefined значит еще не загружалось
      //    dataObj.loading === 'first' -первая (или первичная) загрузка объекта
      //    dataObj.loading === 'update' -обновление объекта который ранее был уже загружен
      //    dataObj.loading === 'partload' -загрузка объекта по частям(страницам)
      //    dataObj.loading === undefined -загрузка не происходит (но судя по наличию dataObj, когда то была)

      if(dataObj?.loading) return; //загрузка уже происходит - идем на выход

      //т.к. пока загрузка не происходит можем ее начать
      if(!dataObj){
        dataSetter({loading:'first'});
      }else{
        //т.к. загрузка уже когда то была, на всякий случай обнулим ошибки
        dataSetter({...dataObj ,loading:'update', error:undefined, abortred:undefined});
      }
      //Посылаем запрос, отлавливая ошибку
      try {
        resp = await getData();
        //Данные приехали. При этом не произошло ошика канального уровня
        if(resp.result!=="OK"){
          if(resp.payload){
            this._errorDecoder(saveErrEndLoading, resp.payload);
             return;
          }else{
            this._errorDecoder(saveErrEndLoading, {code:1, message:'Unprocessed server message'});
            return;
          }
        }else{
          //Чистим ошибки
          this._errorDecoder(saveErr);
        }
      }catch(e){
        //Произошло ошибка канального уровня
        this._errorDecoder(saveErrEndLoading, e);
        return
      }

      //тут нам надо понять - приехали все данные, или только часть
      let { meta } = resp;
      if (meta && meta.to && meta.total && meta.to<meta.total){
        //приехала только часть данных, то что приехало сохраняем (и спрашиваем остальное)
        dataSetter({
          data: resp.payload,
          partSize: (meta.from!==undefined)?(meta.to - meta.from + 1):undefined,
          from: meta.from,
          to: meta.to,
          total: meta.total,
          loading: 'partload'
        });
        let cursor = meta.to
        let errCount = 0;
        const errLimit = 3;
        while(meta && meta.to && meta.total && meta.to<meta.total && errCount<errLimit){
          try {
            resp = await getData(cursor + 1);
            //Данные приехали. При этом не произошло ошика канального уровня
            if(resp.result!=="OK"){
              if(resp.payload){
                this._errorDecoder(saveErrEndLoading, resp.payload);
                return;
              }else{
                this._errorDecoder(saveErrEndLoading, {code:0, message:'Unprocessed server message'});
                return;
              }
            }else{
              //Чистим ошибки
              this._errorDecoder(saveErr);
              errCount=0;
            }
          }catch(e){
            //Произошло ошибка канального уровня, только для таких ошибок выполняются повторные попытки запроса
            const { aborted } = dataGetter();
            this._errorDecoder(saveErr, e);
            if(aborted) break;
            errCount++;
            continue;
          }
          ({ meta } = resp);

          dataSetter({
            ...dataGetter(),
            data:[...dataGetter().data, ...resp.payload],
            partSize: (meta.from!==undefined)?(meta.to - meta.from + 1):undefined,
            from: meta.from,
            to: meta.to,
            total: meta.total
          });
          cursor = meta.to
        }
        dataSetter({...dataGetter(), loading: undefined});

      }else{
        //за один раз к нам приехали все данные
        dataSetter({data:resp.payload, partSize:1, from:1, to:1, total:1});
      }
    })
  }

  _dataLoader = async ({point:apiPoint, payload, varGet=()=>({}), varSaver=()=>{}, from, respParser=JSON.parse})=>{
    //Основная ф-ция выполняющая запрос к беку.
    /*
      порядок загрузки:
      //было
      1 {loading: "update", data} || {loading: "first"}
      2.a (успешная загрузка)
        {to: 1,total: 1, data} ||
        {loading: 'partload', to: n, total: n+m, data: []}
      2.b (ошибка)
        {error: {code: 0, message: "Бла-бла-бла описание ошибки"}}
      //стало
      1.1 (отпрвка запроса, ожидание ответа)
        {loading: "update", loadStage:"sending/pending", data, abort:()=>{}} ||
        {loading: "first", loadStage:"sending/pending", abort:()=>{}}
      1.2 (получение данных)
        {loading: "update", loadStage:"downloading", loadBytes:27879, totalBytes:249936||undefined, data, abort:()=>{}} ||
        {loading: "first", loadStage:"downloading", loadBytes:27879, totalBytes:249936||undefined, abort:()=>{}}
      2.a (успешная загрузка)
        {to: 1,total: 1, data, abort:undefined} ||
        {loading: 'partload', to: n, total: n+m, data: [], abort:()=>{}}
      2.b (ошибка)
        {error: {code: 0, message: "Бла-бла-бла описание ошибки"}}
      2.c (загрузка прервана)
        {abortred:true}
    */
    const uuid = v1();
    const request = this._buildRequest({payload, uuid, from});
    const abortController = (AbortController)?(new AbortController()):{};
    const signal = abortController?.signal;

    const initParam = this._buildInitParam({request, signal});
    const url = this._buildUrl(apiPoint);
    const logableEvent={
      uuid,
      url,
      point:apiPoint, //нужно, чтоб логер мог упрощенно распознавать ЗАПРЕЩЕННЫЕ адреса
      request,
      requestInitParam:JSON.stringify({...initParam, body:undefined}),
      requestTime:new Date(),
      response:'',
      responseHeaders:'',
      responseTime:'',
      isError:false,
      isAborted:false,
      error:'',
    };
    //Обновляем объект сохранения - этап 1.1
    varSaver({
      ...varGet(),
      loadStage: "sending/pending",
      abort: ()=>{
        varSaver({
          ...varGet(),
          loadStage: "aborting",
          aborted:true,
        })
        abortController.abort()
      }
    });
    let response;
    try{
      response = await fetch(url,initParam);
    }catch (e) {
      if(response?.headers) logableEvent.responseHeaders=this._parseResponseHeaders(response.headers)
      logableEvent.responseTime=new Date();
      let error;
      if(signal?.aborted){
        error ={code:0, message:`Получение данных из ${url} было отменено на стороне клиетна
        Сообщение о прерывании: ${e}`};
        logableEvent.isAborted=true;
        //varSaver({abortred:true});
      }else{
        error={code:10000, message:`Не получилось открыть ${url}
        Сообщение об ошибке: ${e}`};
        logableEvent.isError=true;
        logableEvent.error=error
        //varSaver({error});
      }
      this._getAddLog()(logableEvent)
      throw error;
    }

    if(!response?.ok){
      if(response?.headers) logableEvent.responseHeaders=this._parseResponseHeaders(response.headers)
      logableEvent.responseTime=new Date();
      const error = {code:10001, message:`Не получилось открыть ${url}
      Получен ответ ${response.status}`};
      logableEvent.isError=true;
      logableEvent.isError=true;
      logableEvent.error=error
      //varSaver({error});
      this._getAddLog()(logableEvent)
      throw error;
    }

    logableEvent.responseHeaders=this._parseResponseHeaders(response.headers);

    // Получаем длину содержимого ответа (если ее отдали)
    const totalBytes = response.headers.has('Content-Length')?(+response.headers.get('Content-Length')):undefined;

    //Обновляем объект сохранения - этап 1.2
    varSaver({
      ...varGet(),
      loadStage:"downloading",
      loadBytes:0,
      totalBytes
    });

    let result;//сюда в случае успеха сунем результат

    try{
      const reader = response.body.getReader();

      // Читаем данные:
      let loadBytes = 0; // количество байт, полученных на данный момент
      let chunks = []; // массив полученных двоичных фрагментов (составляющих тело ответа)
      for(let {done,value} =await reader.read();!done;({done, value}=await reader.read())){
        chunks.push(value);
        loadBytes += value.length;
        //Обновляем объект сохранения - этап 1.2
        varSaver({
          ...varGet(),
          loadBytes,
        });
      }
      //Получение данных закончено, отмечаем время в объекте лога
      logableEvent.responseTime=new Date();

      varSaver({
        ...varGet(),
        loadStage: "parsing",
        totalBytes:loadBytes,
        loadBytes,
        abort: undefined
      });

      // Cоединим фрагменты в общий типизированный массив Uint8Array
      let chunksAll = new Uint8Array(loadBytes); // (4.1)
      let position = 0;
      for(let chunk of chunks) {
        chunksAll.set(chunk, position); // (4.2)
        position += chunk.length;
      }

      // Декодируем Uint8Array обратно в строку
      result = new TextDecoder("utf-8").decode(chunksAll);
    }catch (e) {
      if(response?.headers) logableEvent.responseHeaders=this._parseResponseHeaders(response.headers)
      let error;
      if(signal?.aborted){
        error ={code:0, message:`Получение данных из ${url} было отменено на стороне клиетна
        Сообщение о прерывании: ${e}`};
        logableEvent.isAborted=true;
        //varSaver({abortred:true});
      }else{
        error={code:10003, message:`Прервалось получение данных из ${url}
        Сообщение об ошибке: ${e}`};
        logableEvent.isError=true;
        logableEvent.error=error
        //varSaver({error});
      }
      this._getAddLog()(logableEvent)
      throw error;
    }

    try{
      //собственно ради безопасного выполнения ф-ции respParser и был открыт этот блок try/catch
      //теоретически с сервера можен прилететь НЕХ которую ф-ция respParser не переживет
      const parsedResult = respParser(result);

      //записываем в лог данные, о штатном завершении запроса
      if(response?.headers) logableEvent.responseHeaders=this._parseResponseHeaders(response.headers);
      logableEvent.response = parsedResult;
      this._getAddLog()(logableEvent);

      return parsedResult;
    }catch(e){
      if(response?.headers) logableEvent.responseHeaders=this._parseResponseHeaders(response.headers)
      let error;
      error={code:10004, message:`Не получилось обработать результат чтения данных из ${url}
      Сообщение об ошибке: ${e},
      сырой результат получения данных ${result}`};
      logableEvent.isError=true;
      logableEvent.error=error
      //varSaver({error});
      this._getAddLog()(logableEvent);
      throw error;
    }
  }
  _errorDecoder(errorSaver, error){
    //ф-ция отдающая пользователю человекочитаемые расшивровки ошибок.
    //использует подключаемую ф-цию errorDecryptor
    errorSaver(errorDecryptor(error));
  }

  _buildInitParam=({request, signal})=>{
    //ф-ция создает объект запроса, исходя из имеющихся настроек
    const init={
      method: this._method, // *GET, POST, PUT, DELETE, etc.
      signal,
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'text/plain' //'application/json;charset=utf-8' // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *client
    };

    if(this._method!=='GET'){
      init.body =  JSON.stringify(request);
    }else if(this.envType!=='PROD'){
      console.log('debug Как буд-то бы мы отправили вот такой объект:', request);
    }
    return init;
  }

  _buildRequest=({payload, uuid, from})=>{
    //ф-ция создает служебную обвязку запроса дополняя его информацией о сессии, пользователе итд
    const { userId, userJwt } = this._getUser();
    return {
      meta:{
        sessionId:this.rr.service_Session?.sessionId,
        utm:this.rr.service_Utm?.utm,
        userId,
        userJwt,
        uuid,
        from,
        timezone: new Date().getTimezoneOffset()*(-60)
      },
      payload,
    }
  }

  _buildUrl=(apiPoint)=>{
    //ф-ция возвращает полный адрес для запроса, слепленный из местных переменных и адреса точки
    const { _host, _port, _path, _suffix } = this;
    return `${_host}${_port!==''?`:${_port}`:''}${_path}${apiPoint}${_suffix}`;
  }

  _parseResponseHeaders=(headers)=>{
    const headerObj={};
    for(let ent of headers.entries()) {
      headerObj[ent[0]]=ent[1];
    }
    return headerObj;
  }

  _getAddLog=()=>{
    //ф-ция которая возвращает функцию добавления события в лог
    //или функцию заглушку, если нету логера или в нем нет нужного метода
    return (this.rr.service_Loger?.addLog)||((e)=>{
      if(this.envType==='DEV'){
        console.log('--------==Эти сообщения видны только в DEV окружении==--------')
        console.log('debug ИМИТАТОР логера был вызван с',e);
        console.log('JSON:',JSON.stringify(e?.request) );
      }else if(this.envType==='TEST'){
        console.log('debug ИМИТАТОР логера делает вид что логирует обращение к ',e?.url);
      }
    });
  }
  _getUser=()=>{
    //ф-ция возвращает из редакс хранилища пользователя или объект-заглушку
    return (this.rr.user_user)||({});
  }

  //ф-ция, которая в сложных (обернутых моделью) объектах вызывается из ф-ции загрузки для
  //сохранения грузимой переменной, посредством ф-ции переданной при вызове ф-ции загрузки
  _callSaver = (data,{saver}) => {
    saver(data)
  }
  //ф-ция, которая в сложных (обернутых моделью) объектах вызывается из ф-ции загрузки для
  //получения грузимой переменной, посредством ф-ции переданной при вызове ф-ции загрузки
  _callGetter = ({geter}) => {
    return geter();
  }
}